import { Card, CardColors, Image, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { HUMANS_OF_HEARD } from './humansOfHeard.config'

export const HumansOfHeard = () => (
  <section className="mx-auto w-full max-w-6xl border-t border-neutral-100 px-4 pb-12 pt-10">
    <div className="mb-2 flex flex-wrap items-baseline justify-between gap-2">
      <div className="flex flex-wrap items-baseline gap-3">
        <Text variant={TypographyStyles.H1} color={TextColors.HEADER}>
          {HUMANS_OF_HEARD.title}
        </Text>
        <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
          {HUMANS_OF_HEARD.subtitle}
        </Text>
      </div>
      <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
        {HUMANS_OF_HEARD.label}
      </Text>
    </div>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {HUMANS_OF_HEARD.winners.map(({ name, photo, value, blurb }) => (
        <Card
          key={name}
          color={CardColors.LEVEL_0}
          className="my-0 h-full border-neutral-50 shadow-xs"
          childrenClassName="p-4"
        >
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <Image
                src={photo}
                alt={name}
                width={48}
                height={48}
                className="h-12 w-12 shrink-0 rounded-full"
              />
              <div className="flex min-w-0 flex-col items-start gap-1">
                <Text
                  variant={TypographyStyles.DISPLAY_XXS}
                  color={TextColors.HEADER}
                >
                  {name}
                </Text>
                <Text
                  variant={TypographyStyles.BODY_XS}
                  color={TextColors.MUTED}
                >
                  {value}
                </Text>
              </div>
            </div>
            <Text
              variant={TypographyStyles.BODY_SM}
              color={TextColors.EMPHASIS}
            >
              {blurb}
            </Text>
          </div>
        </Card>
      ))}
    </div>
  </section>
)
